var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.833313C8.18702 0.833313 6.41474 1.37093 4.90729 2.37817C3.39984 3.38542 2.22492 4.81706 1.53112 6.49205C0.837315 8.16704 0.655785 10.0101 1.00948 11.7883C1.36318 13.5665 2.23622 15.1998 3.5182 16.4818C4.80018 17.7638 6.43353 18.6368 8.21169 18.9905C9.98985 19.3442 11.833 19.1627 13.5079 18.4689C15.1829 17.7751 16.6146 16.6002 17.6218 15.0927C18.6291 13.5853 19.1667 11.813 19.1667 9.99998C19.1638 7.56971 18.1971 5.2398 16.4787 3.52133C14.7602 1.80287 12.4303 0.83618 10 0.833313ZM2.50001 9.99998C2.49935 8.29929 3.08006 6.64946 4.14585 5.32415L14.6758 15.8541C13.5738 16.7375 12.2444 17.2913 10.8411 17.4516C9.43786 17.6119 8.01784 17.3723 6.74493 16.7603C5.47201 16.1482 4.39805 15.1888 3.64697 13.9927C2.89588 12.7965 2.49827 11.4124 2.50001 9.99998ZM15.8542 14.6758L5.32418 4.14581C6.76354 2.99198 8.57804 2.40985 10.42 2.51095C12.262 2.61205 14.0019 3.38928 15.3063 4.69371C16.6107 5.99813 17.3879 7.73802 17.489 9.57999C17.5901 11.422 17.008 13.2365 15.8542 14.6758Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlock);
export default __webpack_public_path__ + "static/media/ic-block.69143a362dc50401f9ecc9070f8be5ed.svg";
export { ForwardRef as ReactComponent };